import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import $ from 'jquery';
import 'select2';
import * as axiosInstance from '../utils/axiosinstace';
import { getUserName } from '../utils/common';
import { useLoading, Bars } from '@agney/react-loading';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { useTranslation } from 'react-i18next';

const ControlSystems = (props) => {
  const { t } = useTranslation(['device', 'common']);
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Bars width="30" color="#333" />,
    });

    const [farmData, setFarmData] = useState([]);
    const [fans, setFans] = useState([]);
    const [selectedFarm, setSelectedFarm] = useState('');
    const [selectedFan, setSelectedFan] = useState('');
    const [showloader, setShowloader] = useState(false);
    const [controlSystemStatus, setControlSystemStatus] = useState('');
    const [resultMessage, setResultMessage] = useState({});
    const [showResults, setShowResults] = useState(false);
    const [selectedMode, setSelectedMode] = useState('');
    const [activeFanID, setActiveFanID] = useState(null);
    const [isLoading, setIsLoading] = useState({});
    const [selectedFanIndex, setSelectedFanIndex] = useState(null);
    const [showRun, setShowRun] = useState(false);
    const [schedulerStatus, setSchedulerStatus] = useState('');
    const initialFormState = {
        selectFarm: '',
        mode: '',
        automationMode: '',
        startTime: '',
        endTime: '',
        onTemperature: '',
        offTemperature: '',
        runTime: '',
        pauseTime: '',
    };

    const {
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        getValues,
        formState: { errors },
    } = useForm({
        defaultValues: initialFormState
    });

    const farmSelection = watch('selectFarm');
    const automationMode = watch('automationMode');

    const onSubmit = async (data) => {
        try {
            data.automatedMode = data.automationMode;
            data.selectedFanIndex = selectedFanIndex + 1;  // Add the index of the selected fan
            data.selectFarm = selectedFarm;
            console.log(data);

            const response = await axiosInstance.controlsystem(data);
            if (response.status) {
                setResultMessage({ error: false, message: t('device:control.updated') });
                setControlSystemStatus('run');
            } else {
                setResultMessage({ error: true, message: t('device:control.updateError') });
            }
            setShowResults(true);
        } catch (err) {
            setResultMessage({ error: true, message: t('device:control.anErrorOccurred') + ' ' + err.message });
            setShowResults(true);
        }
    };

    // Fetch farms on component load
    const getFarms = async () => {
        try {
            const response = await axiosInstance.getListofFarms(getUserName());
            setFarmData(response.list);
        } catch (err) {
            console.log("Error fetching farms: " + err.message);
        }
    };

    // Fetch fans based on selected farm
    const getFansByFarm = async (farmID) => {
        try {
            const response = await axiosInstance.getFansByFarm(farmID);
            console.log(response);
            if (response.list.length > 0) {
                setFans(response.list);
            } else {
                setFans([]);
                setSelectedFan('');
            }
        } catch (err) {
            console.log("Error fetching fans: " + err.message);
        }
    };

    // Fetch existing configuration for the selected farm and fan
    const getControlSystemData = async (farmID, fanID) => {
        setShowResults(false);
        setSelectedFarm(farmID);

        try {
            const response = await axiosInstance.getControlSystemData(farmID, fanID);
            console.log(response)
            if (response.list.length > 0) {

                setShowRun(true);
                setSchedulerStatus(response.list[0].status);
                reset({
                    selectFarm: response.list[0].farmID,
                    startTime: response.list[0].startTime,
                    endTime: response.list[0].endTime,
                    onTemperature: response.list[0].onTemp,
                    offTemperature: response.list[0].offTemp,
                    runTime: response.list[0].runTime,
                    pauseTime: response.list[0].pauseTime,
                    setSelectedFan: response.list[0].fanID,

                })
                setValue('mode', 'automation', {
                    shouldTouch: true,
                    shouldDirty: true,
                })
                setSelectedMode('automation')
                setControlSystemStatus(response.list[0].status);
                setValue('automationMode', response.list[0].automationMode, {
                    shouldTouch: true,
                    shouldDirty: true,
                })
            } else {
                reset(initialFormState);
                setSelectedMode('');
                setControlSystemStatus('stopped');  // Set status as 'stopped' or any appropriate default when no data exists
                setShowRun(false); // Hide the run-related buttons if there is no data

                // Reset the form fields to empty
                setValue('mode', '', { shouldTouch: true, shouldDirty: true });
                setValue('automationMode', '', { shouldTouch: true, shouldDirty: true });
                setValue('startTime', '');
                setValue('endTime', '');
                setValue('onTemperature', '');
                setValue('offTemperature', '');
                setValue('runTime', '');
                setValue('pauseTime', '');
            }
        } catch (err) {
            console.log(err.message);
        }
    }
    const onFarmChangeHandler = (farmID) => {
          // Set selected farm
       
        setFans([]);              // Reset fans
        setSelectedFan('');       // Reset selected fan
        setSelectedMode('');      // Reset mode
        setControlSystemStatus('');  // Reset control system status
        getFansByFarm(farmID);    // Fetch fans for the selected farm
    };
    // useEffect(() => {
    //     getFarms();
    //     $(document).ready(function () {
    //         $('#selectFarm').select2();
    //         $('#selectFarm').on('change', function (e) {
    //             setSelectedFarm(e.target.value);
    //             setValue('selectFarm', e.target.value);
    //             onFarmChangeHandler(e.target.value);  // Ensure farmID is passed correctly
                
    //         });
    //     });

    //     // Cleanup function to remove the event listener
    //     return () => {
    //         $('#selectFarm').off('change');
    //     };
    // }, [setSelectedFarm]);
    useEffect(() => {
        getFarms();
        const selectFarm = $('#selectFarm');
        selectFarm.select2();
        selectFarm.on('change', function (e) {
            const farmID = e.target.value;
            setSelectedFarm(farmID);
            setValue('selectFarm', farmID);
            onFarmChangeHandler(farmID);
        });
    
        // Cleanup on unmount
        return () => {
            selectFarm.off('change');
            selectFarm.select2('destroy');
        };
    }, []);

    const handleFanChange = async (e) => {
        const fanID = e.target.value;
        setSelectedFan(fanID);
        const index = fans.findIndex(fan => fan.fanID === parseInt(fanID));

        setSelectedFanIndex(index); // Store the index of the selected fan
        setValue('selectFan', fanID);
        //alert(selectedFarm, fanID)
        await getControlSystemData(selectedFarm, fanID); // Fetch and prepopulate data for the selected fan
    };
    // const handleFanChange = (e) => {
    //     const fanID = e.target.value;
    //     setSelectedFan(fanID);

    //     if (!fanID) {
    //         setSelectedMode('');
    //         reset(initialFormState);
    //         return;
    //     }

    //     // Fetch and prepopulate data for the selected fan
    //     getControlSystemData(selectedFarm, fanID);
    // };

    const handleModeChange = (e) => {

        setSelectedMode(e.target.value);
    };

    const handleToggle = async (itemId, fanID, checked) => {
        // Set the loader active for this fan
        setIsLoading(prevState => ({
            ...prevState,
            [itemId]: true  // Loader for the fan's index
        }));

        const status = checked ? 'ACTIVE' : 'INACTIVE'; // Determine the new status

        const data = { fanID: fanID, status: status }; // Payload for the API call
        try {
            const response = await axiosInstance.updateFanStatus(data); // Invoke the API
            if (!response.message) {
                alert(t('device:control.switchError'));
                return;
            }

            // Update the fan status locally in the state
            setFans(prevFans => prevFans.map(fan =>
                fan.fanID === fanID ? { ...fan, swtichStatus: status } : fan
            ));

            // Set loader inactive after the API call is done
            setIsLoading(prevState => ({
                ...prevState,
                [itemId]: false  // Loader stops after completion
            }));

            // Update the active fan state
            if (checked) {
                setActiveFanID(fanID);  // Set the active fan
            } else {
                setActiveFanID(null);   // Reset if turned off
            }

        } catch (err) {
            alert(err.response.data.message);
            setIsLoading(prevState => ({
                ...prevState,
                [itemId]: false  // Stop the loader in case of error
            }));
        }
    };


    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                const displayTime = `${hour % 12 === 0 ? 12 : hour % 12}:${minute.toString().padStart(2, '0')} ${hour < 12 ? 'AM' : 'PM'}`;
                options.push(<option key={time} value={time}>{displayTime}</option>);
            }
        }
        return options;
    };
    const stopScheduler = async (e) => {
        e.preventDefault();
        const isConfirmed = window.confirm('Are you sure you want to stop the scheduler?');

        if (isConfirmed) {
            try {
                const data = {
                    farmID: getValues('selectFarm'),
                    status: 'stopped',
                    fanIndex: selectedFanIndex + 1,
                    fanID: selectedFan
                };
                console.log(data)
                const response = await axiosInstance.updateConstrolSystemStatus(data);
                if (!response.status) {
                    alert(response.message);
                } else {
                    setControlSystemStatus('stopped');
                    alert(response.message);
                }
            } catch (err) {
                alert(err.message);
            }
        }
    };

    return (
        <div className="batchOperations">
            <div className="row mb-2">
                <div className="col-sm-6">
                    <h2 className="m-0 text-dark">{t('device:control.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* Display Success/Error Message */}
                        {showResults && <Results message={resultMessage.message} error={resultMessage.error} />}

                        {/* Farm Selection */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="selectFarm" className="form-label">{t('device:control.selectFarm')}</label>
                                    <select
                                        id="selectFarm"
                                        // {...register('selectFarm', { required: true })}
                                        className="form-control form-control-sm"
                                        
                                    >
                                        <option value="">{t('common:select.dashed')}</option>
                                        {farmData.map(farm => (
                                            <option key={farm.farmID} value={farm.farmID}>
                                                {farm.farmName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.selectFarm && <div className="err-msg">{t('device:control.farmRequired')}</div>}
                                </div>
                            </div>
                        </div>
                        {/* Fan Selection */}
                        {selectedFarm && (
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="selectFan" className="form-label">{t('device:control.selectFan')}</label>
                                        <select
                                            id="selectFan"
                                            {...register('selectFan', { required: true })}
                                            className="form-control form-control-sm"
                                            onChange={handleFanChange}
                                        >
                                            <option value="">{t('common:select.dashed')}</option>
                                            {fans.map((fan, index) => (
                                                <option key={fan.fanID} value={fan.fanID}>
                                                    {index === fans.length - 1 ? 'Cooling Pads' : fan.fanName || `Fan ${index + 1}`}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.selectFan && <div className="err-msg">{t('device:control.fanRequired')}</div>}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Mode Selection */}
                        {
                            selectedFan ? (
                                <div className="row">
                                    <div className="col-md-4">
                                        <span><strong>{t('device:control.selectMode')} </strong>&nbsp; &nbsp;</span>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="manualMode"
                                                value="manual"
                                                {...register('mode', { required: true })}
                                                onChange={handleModeChange}
                                                disabled={controlSystemStatus === 'run'}
                                            />
                                            <label className="form-check-label" htmlFor="manualMode">
                                                {t('device:control.manual')}
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id="automationMode"
                                                value="automation"
                                                {...register('mode', { required: true })}
                                                onChange={handleModeChange}
                                            />
                                            <label className="form-check-label" htmlFor="automationMode">
                                                {t('device:control.automation')}
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        {showloader ?
                                            <section {...containerProps} style={{ marginTop: "30px" }}>
                                                {indicatorEl} {/* renders only while loading */}
                                            </section> : null
                                        }
                                    </div>
                                </div>
                            ) : null
                        }

                        {/* Manual Mode: Fan Control */}
                        {/* Manual Mode: Fan Control */}
                        {
                            selectedMode === 'manual' && selectedFan ? (
                                <div style={{ marginTop: 20 }}>
                                    {fans.map((item, index) => (
                                        item.fanID === parseInt(selectedFan) && (  // Check if the current fan is the selected fan
                                            <div className="row" key={index} style={{ marginBottom: 15 }}>
                                                <div className="col-md-2">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            {
                                                                item.swtichStatus === 'ACTIVE' ?
                                                                    <div className="heading-img">
                                                                        <img src="/dist/img/fan.png" className='rotating' alt={t('device:control.activeFan')} />
                                                                    </div>
                                                                    : <div className="heading-img">
                                                                        <img src="/dist/img/fan_grey.png" alt={t('device:control.inactiveFan')} />
                                                                    </div>
                                                            }
                                                        </div>
                                                        <div className="col-md-8" style={{ marginTop: 6 }}>
                                                            <span className="fanLabel">
                                                                {index === fans.length - 1 ? 'Cooling Pads' : `Fan ${index + 1}`}  {/* Use index+1 for fan number */}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-1" style={{ marginTop: 15 }}>
                                                    <BootstrapSwitchButton
                                                        checked={item.swtichStatus === 'ACTIVE'}
                                                        disabled={activeFanID !== null && activeFanID !== item.fanID}
                                                        onChange={(checked) => handleToggle(index, item.fanID, checked)}  // Pass the index for the loader
                                                        width={80}
                                                    />
                                                </div>

                                                {/* Loader next to the switch button */}
                                                <div className="col-md-1" style={{ marginLeft: 10 }}>
                                                    {isLoading[index] && (
                                                        <section {...containerProps} style={{ "margin-top": "0px" }}>
                                                            {indicatorEl} {/* Loader renders only while loading */}
                                                        </section>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                            ) : null
                        }


                        {/* Automation Mode Fields */}
                        {selectedMode === 'automation' && selectedFan && (
                            <>
                                {/* Automation Mode Selection */}
                                <div className="row" style={{ marginTop: 20 }}>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="automationMode" className="form-label">{t('device:control.automationMode')}</label>
                                            <select
                                                {...register('automationMode', { required: true })}
                                                className="form-control form-control-sm"
                                                disabled={controlSystemStatus === 'run'}
                                            >
                                                <option value="">{t('common:select.dashed')}</option>
                                                <option value="Threshold">Threshold</option>
                                                <option value="Timer">Timer</option>
                                            </select>
                                            {errors.automationMode && <div className="err-msg">{t('device:control.modeRequired')}</div>}
                                        </div>
                                    </div>
                                </div>

                                {/* Automation Settings */}
                                {/* {automationMode === 'Threshold' && selectedFan && (
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label htmlFor="startTime" className="form-label">{t('device:control.startTime')}</label>
                                            <select {...register('startTime', { required: t('forms:requiredField.startTime') })} className="form-control form-control-sm">
                                                <option value="">{t('common:select.dashed')}</option>
                                                {generateTimeOptions()}
                                            </select>
                                            {errors.startTime && <div className="err-msg">{t('device:control.startTimeRequired')}</div>}
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="endTime" className="form-label">{t('device:control.endTime')}</label>
                                            <select {...register('endTime', { required: t('forms:requiredField.endTime') })} className="form-control form-control-sm">
                                                <option value="">{t('common:select.dashed')}</option>
                                                {generateTimeOptions()}
                                            </select>
                                            {errors.endTime && <div className="err-msg">{t('device:control.endTimeRequired')}</div>}
                                        </div>


                                    </div>
                                    
                                )} */}
                                {automationMode === 'Threshold' && selectedFan && (
                                    <div className="row" style={{ marginTop: 15 }}>
                                        <div className="col-md-2">
                                            <label htmlFor="onTemperature" className="form-label">{t('device:control.onTemp')}</label>
                                            <input
                                                type="number"
                                                {...register('onTemperature', { required: t('forms:requiredField.onTemp'), min: 0 })}
                                                className="form-control form-control-sm"
                                            />
                                            {errors.onTemperature && <div className="err-msg">{t('device:control.onTempPositive')}</div>}
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="offTemperature" className="form-label">{t('device:control.offTemp')}</label>
                                            <input
                                                type="number"
                                                {...register('offTemperature', { required: t('forms:requiredField.offTemp'), min: 0 })}
                                                className="form-control form-control-sm"
                                            />
                                            {errors.offTemperature && <div className="err-msg">{t('device:control.offTempPositive')}</div>}
                                        </div>
                                    </div>
                                )}
                                {automationMode === 'Timer' && selectedFan && (
                                    <>
                                        <div className="row">
                                            <div className="col-md-2">
                                                <label htmlFor="startTime" className="form-label">{t('device:control.startTime')}</label>
                                                <select {...register('startTime', { required: t('forms:requiredField.startTime') })} className="form-control form-control-sm">
                                                    <option value="">{t('common:select.dashed')}</option>
                                                    {generateTimeOptions()}
                                                </select>
                                                {errors.startTime && <div className="err-msg">{t('device:control.startTimeRequired')}</div>}
                                            </div>
                                            <div className="col-md-2">
                                                <label htmlFor="endTime" className="form-label">{t('device:control.endTime')}</label>
                                                <select {...register('endTime', { required: t('forms:requiredField.endTime') })} className="form-control form-control-sm">
                                                    <option value="">{t('common:select.dashed')}</option>
                                                    {generateTimeOptions()}
                                                </select>
                                                {errors.endTime && <div className="err-msg">{t('device:control.endTimeRequired')}</div>}
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: 20 }}>
                                            <div className="col-md-2">
                                                <label htmlFor="runTime" className="form-label">{t('device:control.runTime')}</label>
                                                <input type="number" {...register('runTime', { required: t('forms:requiredField.runTime') })} className="form-control form-control-sm" />
                                                {errors.runTime && <div className="err-msg">{t('device:control.runTimeRequired')}</div>}
                                            </div>
                                            <div className="col-md-2">
                                                <label htmlFor="pauseTime" className="form-label">{t('device:control.pauseTime')}</label>
                                                <input type="number" {...register('pauseTime', { required: t('forms:requiredField.pauseTime') })} className="form-control form-control-sm" />
                                                {errors.pauseTime && <div className="err-msg">{t('device:control.pauseTimeRequired')}</div>}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        )}

                        {selectedMode === 'automation' && automationMode !== '' && selectedFan && (
                            <div className="row" style={{ marginTop: 15 }}>
                                <div className="col-md-12">
                                    {
                                        controlSystemStatus !== 'run' ? (
                                            <input type="submit" value="Save & Run" className="btn btn-primary newBtn" />
                                        ) : (
                                            <>
                                                <a className="btn btn-danger newBtn" onClick={(e) => stopScheduler(e)} style={{ color: '#fff' }}>
                                                   
                                                {automationMode === 'Timer' ? "Stop Scheduler" : automationMode === 'Threshold' ? "Disable Automation" : 'Stop'}
                                                </a>
                                                <p style={{ marginTop: 10 }}>
                                                    {t('device:control.manualModeNote')}
                                                </p>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        )}

                    </form>
                </div>
            </div>
        </div>
    );
};

const Results = (props) => {
    let error, classes;
    if (props.error === false) {
        error = 'Success';
        classes = 'alert alert-success alert-dismissible fade show';
    } else {
        error = 'Error!';
        classes = 'alert alert-danger alert-dismissible fade show';
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}
                <button type="button" className="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
};

export default ControlSystems;
